import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apartment-two',
  templateUrl: './apartment-two.component.html',
  styleUrls: ['./apartment-two.component.css']
})
export class ApartmentTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/apartment-two/apartment-two.component.ts